module.exports = __webpack_public_path__ + "icon_forefinger.9c7d553270b04d0d835a91041fbe8f29.svg";